export const SHEET_JSON_URL =
  'https://docs.google.com/spreadsheets/d/1wFaXZuNszRx_sHm47w0x7BviN9wOrwXOOb325ipjw5o/gviz/tq?tqx=out:json&sheet=Sheet1';
export const SHEET_VIEW_URL =
  'https://docs.google.com/spreadsheets/d/1wFaXZuNszRx_sHm47w0x7BviN9wOrwXOOb325ipjw5o/edit?usp=sharing';

function parseGvizFeedbackText(text) {
  const jsonStart = text.indexOf('{');
  const jsonEnd = text.lastIndexOf('}');
  if (jsonStart === -1 || jsonEnd === -1) {
    throw new Error('Unexpected sheet response format');
  }

  const parsed = JSON.parse(text.slice(jsonStart, jsonEnd + 1));
  const table = parsed.table || {};
  const cols = (table.cols || []).map(col => col.label || '');
  const rows = table.rows || [];

  return rows.map(row => {
    const obj = {};
    (row.c || []).forEach((cell, idx) => {
      const key = cols[idx];
      if (!key) return;
      const value = cell ? cell.f ?? cell.v ?? '' : '';
      obj[key] = value;
    });

    return {
      time: obj.time || '',
      class: obj.class ?? '',
      subject: obj.subject || '',
      class_name: obj.class_name || '',
      teacher_name: obj.teacher_name || '',
      student_name: obj.student_name || '',
      student_phone: obj.student_phone || '',
      rating: obj.rating ?? '',
      feedback: obj.feedback || '',
    };
  });
}

/** `undefined` means no successful load yet (empty array [] is a valid cache). */
let cachedRows;
let inFlightPromise = null;

export function peekFeedbackFeedbacksCache() {
  return cachedRows;
}

/**
 * Loads feedback rows from the sheet. Deduplicates concurrent calls and returns
 * the same promise until settled. Use `bypassCache` after a failed load to retry.
 */
export async function fetchFeedbackFeedbacks({ bypassCache = false } = {}) {
  if (bypassCache) {
    cachedRows = undefined;
  }
  if (!bypassCache && cachedRows !== undefined) {
    return cachedRows;
  }
  if (!bypassCache && inFlightPromise) {
    return inFlightPromise;
  }

  inFlightPromise = (async () => {
    const response = await fetch(SHEET_JSON_URL);
    if (!response.ok) {
      throw new Error('Failed to load sheet data');
    }
    const text = await response.text();
    const mapped = parseGvizFeedbackText(text);
    cachedRows = mapped;
    return mapped;
  })();

  try {
    return await inFlightPromise;
  } finally {
    inFlightPromise = null;
  }
}
